import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveToLocalStorage = (key: string, value: any): void => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (e) {
    console.error(`Could not save value for key "${key}" to localStorage`, e);
  }
};
export const loadFromLocalStorage = <T>(key: string): T | undefined => {
  try {
    const serializedValue = localStorage.getItem(key);

    if (serializedValue === null) {
      return undefined;
    }

    return JSON.parse(serializedValue) as T;
  } catch (e) {
    console.error(`Could not load value for key "${key}" from localStorage`, e);
    return undefined;
  }
};
